import React from "react";
import styled from "styled-components";
import Image from "../../../components/Image/Image";
import ImageCrop from "../UI/Image/ImageCrop";
import { A } from "../GlobalStyle/Utilities";

//Usage:
/*
<CastMember
    image="https://via.placeholder.com/400x500"
    fullName="Name"
    role="Role">
    <p>Lorem ipsum dolor sit amet, consectotetur <a href="/">adipiscing</a> elit, sed do eiusmod tempor.</p>
    <LinkButton variant="cta-text-link" to="/" target="_self" align="center">Om kunsteren</LinkButton>
</CastMember>
*/

interface CastMemberProps
{
    image?: string;
    fullName: string;
    role: string;
}

const CastMemberWrap = styled.div`
    position: relative;
    z-index: 0;
    white-space: initial;
    font-size: 1rem;
    /*color: var(--color-gray-60, black);*/
    text-align: center;
    img {
        filter: grayscale(100%);
    }
    a {
        ${A}
        opacity: .5;
        &:after {
            margin: 0 auto;
        }
        &:hover {
            opacity: 1;
        }
    }
`;

const CastMemberText = styled.div`
    padding: 1rem 0;
`;

const CastMemberName = styled.div`
    font-size: 1.25rem;
    margin-bottom: .5rem;
    line-height: 1.3;
`;

const CastMemberRole = styled.div`
    text-transform: uppercase;
    opacity: .5;
    margin-bottom: .5rem;
`;

const CastMemberImage = styled.div`
    position: relative;
    width: 100%;
    overflow: hidden;
    img {
        transform: scale(1);
        transition: transform .3s ease-out;
    }
    &:hover {
        img {
            transform: scale(1.05);
        }
        .cm__text {
            transform: translateY(0);
        }
        .cm__description {
            opacity: 1;
            pointer-events: auto;
        }
    }
`;

const CastMemberDescription = styled.div`
    background-color: rgba(255,255, 255, 0.66);
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    padding: 1.5rem;
    text-align: center;
    transition: opacity .3s;
    opacity: 0;
    pointer-events: none;
    .cm__text {
        position: relative;
        z-index: 0;
        transform: translateY(50%);
        transition: transform .3s;
        p {
            margin-bottom: 1rem;
        }
    }
    p a {
        color: var(--color-gray-40, gray);
    }
`;

const CastMember: React.FunctionComponent<CastMemberProps> = (props) =>
{
    const { image, children, fullName, role } = props;

    return (
        <CastMemberWrap>
            {
                children && image ?
                    <CastMemberImage>
                        <ImageCrop src={image} heightRatio={5/4} alt={fullName} />
                        <CastMemberDescription className="cm__description">
                            <div className="cm__text">{children}</div>
                        </CastMemberDescription>
                    </CastMemberImage>
                    :
                    image ? <Image src={image} width={4} height={5} alt={fullName} aspectRatio /> : null
            }
            <CastMemberText>
                <CastMemberName>{fullName}</CastMemberName>
                <CastMemberRole className="text-xSmall">{role}</CastMemberRole>
            </CastMemberText>
        </CastMemberWrap>);
};

export default CastMember;